import { PerfisReadOnly } from 'utils/types/perfil';

const isUsuarioSomenteLeitura = (perfilIDs: number[]) => {
  return perfilIDs.some((perfilID: number) =>
    PerfisReadOnly.includes(perfilID),
  );
};

export { isUsuarioSomenteLeitura };
